import { FormControl } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-amount-error',
  templateUrl: './amount-error.component.html',
  styleUrls: ['./amount-error.component.scss'],
})
export class AmountErrorComponent {
  @Input() amount: FormControl;
  @Input() minAmount: number;
  @Input() maxAmount: number;
}
